export const getGeoCountryNameById = ({ list = [], id = "" }) => {
	if (id === "" || id == null) return "";

	const match = [...(list || [])].find(({ id: countryId }) => String(countryId) === String(id));

	return match?.name || "";
};

export const normalizeTermsCountryName = (value = "") =>
	decodeURIComponent(String(value || "").trim()).toLowerCase();

export const isTermsConditionsPolicyFallback = ({
	requestedCountryName = "",
	policyCountry = "",
	source = "",
} = {}) => {
	if (!requestedCountryName) return false;

	if (source === "segment_default") return true;

	const requested = normalizeTermsCountryName(requestedCountryName);
	const policy = normalizeTermsCountryName(policyCountry);

	return Boolean(requested && policy && requested !== policy);
};

export const getLegacyTermsConditionsPageContent = (globals) =>
	globals?.pages?.find(({ slug }) => slug?.toLowerCase() === "terms-and-conditions")?.content || "";

export const getTermsConditionsPolicyContent = (globals) => {
	const policyContent = globals?.terms_conditions_policy?.content;
	if (policyContent) return policyContent;

	return getLegacyTermsConditionsPageContent(globals);
};

export const hasRegistrationTermsConditionsContent = (globals) =>
	Boolean(globals?.terms_conditions_policy?.content);

export const hasLegacyTermsConditionsPage = (globals) =>
	Boolean(getLegacyTermsConditionsPageContent(globals));

export const hasTermsConditionsDisplayContent = (globals) =>
	Boolean(getTermsConditionsPolicyContent(globals));
